import { render, staticRenderFns } from "./splitAccountingLayOut.vue?vue&type=template&id=10c7ca26&scoped=true"
import script from "./splitAccountingLayOut.vue?vue&type=script&lang=js"
export * from "./splitAccountingLayOut.vue?vue&type=script&lang=js"
import style0 from "./splitAccountingLayOut.vue?vue&type=style&index=0&id=10c7ca26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7ca26",
  null
  
)

export default component.exports